/**
 * Global transformer which does various things:
 * - adds auth token if kpi request and not in production
 * - sets withCredentials flag if not apptrace request
 */
function Transformer() {
  'ngInject';
  return {
    request: request
  };

  function request(httpConfig) {

    if (httpConfig.withCredentials !== false) {
      httpConfig.withCredentials = true;
    }

    if (httpConfig.withoutXhrHeader !== true) {
      // Without this the sign_in request returns ERROR 406
      // Rails needs this header. See https://groups.google.com/forum/?fromgroups=#!topic/angular/k8iEHBmQrJo
      httpConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
    }

    return httpConfig;

  }
}

export { Transformer };
